import { curryN } from 'ramda';
import React from 'react';

/**
 *  Utils to allow override props in components no instantiated
 *
 * @param {Object} overProps - Props to override in the component
 * @param {Function} Component
 * @returns
 */
export const withProps = (overProps, Component) => props => <Component {...props} {...overProps} />;

export const withPropsCurry = curryN(2, withProps);
